var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2IconShoehorn = function SvgS2IconShoehorn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 450 450"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "s2_icon_shoehorn_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h450v450H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#464646",
    strokeWidth: 26,
    clipPath: "url(#s2_icon_shoehorn_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5 169.833 267.941 52.206s52.674-20.679 101.979 2.616 47.152 55.9 47.152 55.9l-8.391 103.111s2.722 18.546-27.569 46-158.093 146.632-158.093 146.632l-44.576-20.554v-114.6l81.847-69.152L71.27 304.076l-35.524-22.337Z",
    "data-name": "Path 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.5 170.1 36.13 24.524 2.687 108.584",
    "data-name": "Path 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m179.555 272.126 46.893 20.112-3.5 113.021",
    "data-name": "Path 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.625 193.8 285.766 82.719s27.275-18.068 63.035-1.747 11.427 36.229 11.427 36.229l-100.669 85.426",
    "data-name": "Path 17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.448 292.216S390.71 149.381 401.155 139.087s19.4-22.19 13.242-42.11",
    "data-name": "Path 18"
  }))));
};
export default SvgS2IconShoehorn;